import React from 'react';
import ContentLoader from 'react-content-loader';
// import Card from '@gerenciatd/next.components.card-n';
import { fakeSettings } from '@/constants/constants';
import FakeList from './FakeList';

const ExtraUsageFake = () => {
  const parentDiv = document.getElementsByClassName('container')[0] || window;
  const contentWidth = parentDiv.clientWidth || window.innerWidth;

  return (
    <div className="ExtraUsageFake">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12" >
            {/* <Card> */}
              <ContentLoader
                width={contentWidth}
                {...fakeSettings}
              >
                <rect x={(contentWidth / 2) - 60} y="10" rx="1" ry="1" width="120" height="20" />
                <rect x={(contentWidth / 2) - 80} y="40" rx="1" ry="1" width="160" height="20" />
                <rect x={(contentWidth / 2) - 40} y="72" rx="1" ry="1" width="80" height="25" />
              </ContentLoader>
              <div className="containerFakeList">
                <FakeList />
                <FakeList />
                <FakeList />
                <FakeList />
              </div>
            {/* </Card> */}
          </div>
        </div>
      </div>
    </div>
  )
}
export default ExtraUsageFake;
